export const Index = r => require.ensure([], () => r(require('./index')), 'resources-bundle');

export default [
  {
    path: 'resources',
    name: 'resources',
    component: Index
  }
];
